import axios from '../util/axiosConfig';
import { message } from 'antd';

import { getErrorMessage } from '../util/ErrorUtils';

export const send2faOtpAPI = (userId, email) => {
    return axios.get(`/api/auth/send-2fa-otp`, {
        params: {
            userId,
            email
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}

export const verifyOtpAPI = (credentials) => {
    return axios.post(`/api/auth/verify`, credentials)
        .then(function (response) {
            if (response.data) {
                return { success: true, tokens: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        })
}

export const sendOTPApi = async ({ queryParams, email }) => {
    return await axios.post(`/api/auth/send-otp?${queryParams}`, { email }).then((response) => {
        if (response.data) return { success: true, data: response.data }
        
        return {success: false}
    }).catch((error) => {
        return {success: false, error: error}
    })
}

export const resetPassword = async (data) => {
    return await axios.post("/api/auth/reset-password", data).then((response) => {
        if (response.data) return { success: true, data: response.data }
        
        return {success: false}
    }).catch((error) => {
        return {success: false, error: error}
    })
}

export const getAuthenticatorDetailsAPI = async (data) => {
    return await axios.get(`/api/auth/otpRequest?email=${data.email}&mode=${data.mode}`).then((response) => {
        if (response) return { success: true, data: response.data }
        return { success: false }
    }).catch((error) => {
        return { success: false, error }
    })
}

export const setIsAuthAPI = async (email) => {
    return await axios.get(`/api/auth/setIsAuth?email=${email}`).then((response) => {
        if (response) return { success: true }
        return { success: false }
    }).catch((error) => {
        return { success: false, error }
    })
}

export const getRadiscanSession = async () => {
    return await axios.get("/api/auth/radiscan-session").then((response) => {
        if (response) return { success: true }
        return { success: false }
    }).catch((error) => {
        return { success: false, error }
    })
}